import React from 'react'
import { Toolbox } from './Toolbox'
import { HistoryList } from '../List'
import type { GraphqlQuery } from '@ztechapps/common.hook'
import { useEntityHistory } from '@ztechapps/common.hook'
import type { TableHeight } from '../../DataTable/types'

type HistoryLayoutProps = {
  filterCategory: string
  query?: GraphqlQuery
  filter: Record<any, any>
  height?: TableHeight
}
/**
 * The default layout for the history
 * @constructor
 */
export const HistoryLayout = ({ filterCategory, query, filter = {}, height }: HistoryLayoutProps) => {
  return <HistoryLayoutBase filterCategory={filterCategory} query={query} filter={filter} height={height} />
}

export const HistoryLayoutBase = ({ query, filter, filterCategory, height }: HistoryLayoutProps) => {
  const entityHistoryResult = useEntityHistory({ query, filter })

  return (
    <>
      <Toolbox {...{ filterCategory, ...entityHistoryResult }} />

      <HistoryList {...entityHistoryResult} height={height} />
    </>
  )
}
